module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQ4jWMYdIAR3UH/82waGBgY6pHFGCcdYfyfZzOfcdKRRFweYEIzRADdECSQADIMQxSbQUQAnIahGMQ46cgHDBWYAKthLBjKcABQOGGXgToCXeB/ns1/DFVYALrBpIYRToDTa7i8gsvFOA3CpQEXGPUaeQY1EqGPGDUDCRgYGAD0NShGgwiWzgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/ic_btn_confirmation.png
// module id = 737
// module chunks = 0